<template>
  <div class="capacity-attachments-badge">
    <CapacityIcon
      :capacity="capacity"
      :allocation="iconAllocation"
      size="small"
      :allow_change="false"
    />
    <EmployeeAssignmentsCounterButton
      :rolesCount="rolesCount"
      :responsibilitiesCount="validResponsibilitiesCount"
      :directResponsibilitiesCount="directResponsibilitiesCount"
      :notActiveDirectResponsibilitiesCount="notActiveDirectResponsibilitiesCount"
      :inProgress="inProgress"
      @click="onClickCounter"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import CapacityIcon from "@components/organizations/positions/PositionCapacityIcon.vue";
import EmployeeAssignmentsCounterButton from "@components/EmployeeAssignmentsCounterButton/EmployeeAssignmentsCounterButton.vue";

const ALLOCATIONS = ["not", "0.5", "2x0.5", "1"];

const props = defineProps({
  /** Position capacity in FTE: 1 or 0.5. */
  capacity: {
    type: Number,
    default: 1,
  },
  /** Free capacity; occupied is capacity minus vacancy. Omitted means nothing is occupied. */
  vacancy: {
    type: Number,
    default: null,
  },
  /** Optional occupied state ("not", "0.5", "2x0.5", "1"); capacity and vacancy alone cannot tell 2 x 0.5 from 1. */
  allocation: {
    type: String,
    default: "",
  },
  validRolesCount: {
    type: Number,
    default: 0,
  },
  invalidRolesCount: {
    type: Number,
    default: 0,
  },
  validResponsibilitiesCount: {
    type: Number,
    default: 0,
  },
  directResponsibilitiesCount: {
    type: Number,
    default: 0,
  },
  notActiveDirectResponsibilitiesCount: {
    type: Number,
    default: 0,
  },
  inProgress: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["click"]);

const rolesCount = computed(() => props.validRolesCount + props.invalidRolesCount);

const iconAllocation = computed(() => {
  if (ALLOCATIONS.includes(props.allocation)) return props.allocation;
  if (props.vacancy === null) return "not";
  const occupied = Math.round((props.capacity - props.vacancy) * 100) / 100;
  if (occupied <= 0) return "not";
  return occupied < 1 ? "0.5" : "1";
});

function onClickCounter(event) {
  // Forward the DOM event so parent listeners can use modifiers (e.g. @click.stop).
  emit("click", event);
}
</script>

<style scoped>
.capacity-attachments-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
</style>
